import { Image, message } from "antd"
import axios from "axios"
import { create } from "zustand"
import { MAIN_URL } from "../../../Constants"

export const useBrands = create((set, get) => ({
    brands: [],
    ed: {},
    setEd: (v) => {
        set({ ed: v })
    },
    columns: [
        {
            title: 'Logo',
            dataIndex: 'logo',
            key: 'logo',
            width: 150,
            render: (_, record) => {
                return (
                    <Image
                        width={50}
                        height={50}
                        src={MAIN_URL + '/' + record.logo}
                        alt={record.nameuz}
                        style={{objectFit: 'contain'}}
                    />
                )
            }
        },
        {
            title: 'Marka nomi',
            dataIndex: 'nameuz',
            key: 'nameuz',
        },
        {
            title: 'Marka nomi',
            dataIndex: 'nameru',
            key: 'nameru',
        },

    ],
    getBrands: () => {
        axios.get('/brands').then(res => {
            set({ brands: res.data })
        }).catch(error => {
            message.error("Ma'lumotlarni olishda muammo yuzaga keldi!!!")
        })
    },
    createBrand: (v) => {
        axios.post('/brands', v).then(res => {
            get().getBrands()
            message.success("Muvaffaqiyatli qo'shildingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni qo'shishda muammo yuzaga keldi!!!")
        })
    },
    updateBrand: (v) => {
        axios.put('/brands/' + v.id, v).then(res => {
            get().getBrands()
            message.success("Muvaffaqiyatli o'zgartirdingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni o'zgartirishda muammo yuzaga keldi!!!")
        })
    },
    deleteBrand: (id) => {
        axios.delete('/brands/' + id).then(res => {
            get().getBrands()
            message.success("Muvaffaqiyatli o'chirdingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni o'chirishda muammo yuzaga keldi!!!")
        })
    }
}))